<template>
  <Transition name="slide-up">
    <div v-if="showDialog" class="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
      <div class="container-custom max-w-5xl mx-auto">
        <div class="relative overflow-hidden bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-200/50">
          <!-- Gradient background -->
          <div class="absolute inset-0 bg-gradient-to-br from-primary-50/50 to-secondary-50/50"></div>
          
          <div class="relative z-10 p-6 md:p-8">
            <div class="flex flex-col md:flex-row items-start md:items-center gap-6">
              <!-- Icon -->
              <div class="flex-shrink-0">
                <div class="w-14 h-14 bg-gradient-to-br from-primary-600 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
                  <CookieIcon class="w-7 h-7 text-white" />
                </div>
              </div>
              
              <!-- Content -->
              <div class="flex-1">
                <h3 class="text-lg md:text-xl font-bold text-gray-900 mb-2">
                  We Value Your Privacy
                </h3>
                <p class="text-gray-600 text-sm md:text-base leading-relaxed">
                  We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
                  By clicking "Accept All", you consent to our use of cookies. 
                  <router-link to="/privacy-policy" class="text-primary-600 hover:text-primary-700 underline font-medium">
                    Learn more
                  </router-link>
                </p>
              </div>
              
              <!-- Actions -->
              <div class="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                <button
                  @click="rejectCookies"
                  class="px-6 py-3 rounded-lg border-2 border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 transition-all duration-200 hover:scale-105 active:scale-95"
                >
                  Reject
                </button>
                <button
                  @click="acceptCookies"
                  class="px-6 py-3 rounded-lg bg-gradient-to-r from-primary-600 to-purple-600 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 active:scale-95"
                >
                  Accept All
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const showDialog = ref(false)

const COOKIE_CONSENT_KEY = 'cookie_consent'

const checkCookieConsent = () => {
  try {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!consent) {
      // Show dialog after a short delay for better UX
      setTimeout(() => {
        showDialog.value = true
      }, 1000)
    }
  } catch (error) {
    console.error('Error checking cookie consent:', error)
  }
}

const acceptCookies = () => {
  try {
    const consentData = {
      accepted: true,
      timestamp: new Date().toISOString()
    }
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentData))
    showDialog.value = false
  } catch (error) {
    console.error('Error saving cookie consent:', error)
  }
}

const rejectCookies = () => {
  try {
    const consentData = {
      accepted: false,
      timestamp: new Date().toISOString()
    }
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentData))
    showDialog.value = false
  } catch (error) {
    console.error('Error saving cookie rejection:', error)
  }
}

onMounted(() => {
  checkCookieConsent()
})
</script>

<script>
export default {
  components: {
    CookieIcon: {
      template: `
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      `
    }
  }
}
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
